// Debounce is borrowed (stolen) from underscore. 
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
var MediaQuery = function(func, query) {
	return function() {
		const tabletWidth = 1200;
		const desktopWidth = 992;

		let context = this;
		let args = arguments;
		// tablet Callbacks
		if (query === 'tablet'){
			if(window.innerWidth > tabletWidth) {
				func.apply(context, args);
			}
		} 
		else if (query === 'nontablet'){
			if(window.innerWidth < tabletWidth) {
				func.apply(context, args);
			}
		} 
		// Mobile Callback
		else if (query === 'mobile'){
			if(window.innerWidth < desktopWidth) {
				func.apply(context, args);
			}
		} 
		// Desktop Callback
		else {
			if(window.innerWidth > desktopWidth) {
				func.apply(context, args);
			}
		}
		
	}
}
module.exports = MediaQuery;



// WEBPACK FOOTER //
// ./lib/mediaQuery.js